import { Component, OnInit } from '@angular/core';
import { NotificationService } from '../../services/notification.service';
import { Router } from '@angular/router';
import { ToasterService } from '../../services/toaster.service';

@Component({
  selector: 'app-push-notification',
  templateUrl: './push-notification.component.html',
  styleUrls: ['./push-notification.component.css']
})
export class PushNotificationComponent {
  enteredPushTitle: string ;
  enteredPushBody: string ;
  enteredURL: string ;
  selectedCommunicationType: string = 'push';
  errorMessage: string;
  selectedLanguage: string = 'all';
  remainingChars: number = 170;
  isFrenchFormVisible: boolean = false;
  remainingTitleChars: number = 50;

  englishData: any = {};
  frenchData: any = {};
 

  constructor(private notificationService: NotificationService, private router: Router, private toaster: ToasterService) {}

  selectLanguage(language: string) {
    if (this.selectedLanguage === 'en') {
      this.englishData = {
        push_title: this.enteredPushTitle,
        push_body: this.enteredPushBody,
        redirect_url: this.enteredURL
      };
    } else if (this.selectedLanguage === 'fr') {
      this.frenchData = {
        push_title: this.enteredPushTitle,
        push_body: this.enteredPushBody,
        redirect_url: this.enteredURL
      };
    } else if (this.selectedLanguage === 'all') {
      if (this.isFrenchFormVisible) {
        this.frenchData = {
          push_title: this.enteredPushTitle,
          push_body: this.enteredPushBody,
          redirect_url: this.enteredURL
        };
      } else {
        this.englishData = {
          push_title: this.enteredPushTitle,
          push_body: this.enteredPushBody,
          redirect_url: this.enteredURL
        };
      }
    }
    this.selectedLanguage = language;
  
    if (this.selectedLanguage === 'en') {
      this.enteredPushTitle = this.englishData.push_title || '';
      this.enteredPushBody = this.englishData.push_body || '';
      this.enteredURL = this.englishData.redirect_url || '';
    } else if (this.selectedLanguage === 'fr') {
      this.enteredPushTitle = this.frenchData.push_title || '';
      this.enteredPushBody = this.frenchData.push_body || '';
      this.enteredURL = this.frenchData.redirect_url || '';
    } else if (this.selectedLanguage === 'all') {
      this.enteredPushTitle = this.englishData.push_title || '';
      this.enteredPushBody = this.englishData.push_body || '';
      this.enteredURL = this.englishData.redirect_url || '';
    }

    this.remainingChars = 170 - this.enteredPushBody.length; 
    this.remainingTitleChars = 50 - this.enteredPushTitle.length;
    this.isFrenchFormVisible = this.selectedLanguage === 'fr';
    this.errorMessage = '';
  }
  
  nextSection() {
    if (!this.enteredPushTitle || !this.enteredPushBody || !this.enteredURL) {
      this.errorMessage = "All fields are mandatory";
      return;
    }
    if (!this.isValidUrl(this.enteredURL)) {
      this.errorMessage = "Enter a valid URL";
      return;
    }

    this.englishData = {
      push_title: this.enteredPushTitle,
      push_body: this.enteredPushBody,
      redirect_url: this.enteredURL
    };
    
      this.enteredPushTitle = this.frenchData.push_title || '';
      this.enteredPushBody = this.frenchData.push_body || '';
      this.enteredURL = this.frenchData.redirect_url || '';

    this.errorMessage = '';
    this.isFrenchFormVisible = true;
    this.remainingChars = 170 - this.enteredPushBody.length; 
    this.remainingTitleChars = 50 - this.enteredPushTitle.length; 
  }
  
  previousSection() {
    this.frenchData = {
      push_title: this.enteredPushTitle,
      push_body: this.enteredPushBody,
      redirect_url: this.enteredURL
    };

    this.enteredPushTitle = this.englishData.push_title;
    this.enteredPushBody = this.englishData.push_body;
    this.enteredURL = this.englishData.redirect_url;
  
    this.isFrenchFormVisible = false;
    this.remainingChars = 170 - this.enteredPushBody.length;
    this.remainingTitleChars = 50 - this.enteredPushTitle.length; 
  }
  
  
  createNotification() {
    if (!this.enteredPushTitle || !this.enteredPushBody || !this.enteredURL){
      this.errorMessage = "All fields are mandatory"
      return
    }
    
    if (!this.isValidUrl(this.enteredURL)) {
      this.errorMessage = "Enter a valid URL";
      return;
    }

    let payload: any = {};
  
    if (this.selectedLanguage === 'all') {
      payload = {
        push: {
          en: this.englishData,
          fr: {
            push_title: this.enteredPushTitle,
            push_body: this.enteredPushBody,
            redirect_url: this.enteredURL
          }
        }
      };
    } else {
      payload = {
        push: {
          [this.selectedLanguage]: {
            push_title: this.enteredPushTitle,
            push_body: this.enteredPushBody,
            redirect_url: this.enteredURL
          }
        }
      };
    }
  
    this.notificationService.createNotification(payload).subscribe(
      (response: any) => {
       this.toaster.openDialogBox("Notification created successfully",true)
      },
      (error: any) => {
        console.error("Error creating notification", error);
        this.errorMessage = "An error occurred while creating the notification";
        if(error.status === 403){
          this.toaster.openDialogBox("You don't have the required permission",true)
        }
      }
    );
  }
  
  private isValidUrl(url: string): boolean {
    try {
      new URL(url);
      return true;
    } catch {
      return false;
    }
  }

  navigate() {
    this.router.navigate(['/notification-list']);
  }

  onPushBodyChange(value: string) {
    this.remainingChars = 170 - value.length;
  }

  onPushTitleChange(value: string) {
    this.remainingTitleChars = 50 - value.length;
  }

  getPlaceholderForTitle(): string {
    return this.isFrenchFormVisible || this.selectedLanguage === 'fr' 
      ? 'Enter the Push Title in French' 
      : 'Enter the Push Title in English';
  }
  
  getPlaceholderForBody(): string {
    return this.isFrenchFormVisible || this.selectedLanguage === 'fr' 
    ? 'Enter the Push Body in French' 
    : 'Enter the Push Body in English';
  }
  
}
